import {
  GridColDef,
  GridRenderCellParams,
  GridTreeNodeWithRender,
} from "@mui/x-data-grid-pro"
import { StudentAcademicStatusDTO } from "../../studentAcademicStatus.dto"
import { ColumnKeys } from "./column.keys"
import { Box, Tooltip, Typography } from "@mui/material"
import { numberSorter } from "./column.sort.comparators"
import { calendarDaysSince } from "../../scoreRecency"
import { PROGRESS_STALL_AFTER_DAYS } from "../../studentFlags"
import clsx from "clsx"

export const ACTIVITY_COLUMNS: GridColDef<StudentAcademicStatusDTO>[] = [
  {
    field: ColumnKeys.LAST_LEARNING_ACTIVITY,
    headerName: "Last progress",
    width: 140,
    valueGetter: (value, studentRow: StudentAcademicStatusDTO) => {
      const timestamp = studentRow.status.activity.lastLearningActivityTimestamp
      return timestamp ? calendarDaysSince(timestamp) : null
    },
    renderCell: (params) =>
      renderDaysDiffCell(
        params,
        params.row.status.activity.lastLearningActivityTimestamp,
      ),
    getSortComparator(sortDirection) {
      return (v1, v2) => numberSorter(v1, v2, sortDirection)
    },
    // Red exactly when the stall signal fires (>14d): the cell, the row's
    // Attention chip and the pill count must agree — a red cell on a row the
    // pill does not count would be the old dishonest flag all over again.
    cellClassName: (params) =>
      clsx("cell", {
        "is-flagged": params.value > PROGRESS_STALL_AFTER_DAYS,
      }),
    type: "number",
  },
  // Attendance lives in the attendance feature — the "Last Live Lesson
  // Attendance" column was removed rather than fixed: its value was actually
  // last-ANY-activity, so the label lied, and the students page must not carry
  // attendance signals of its own.
]

function renderDaysDiffCell(
  params: GridRenderCellParams<
    StudentAcademicStatusDTO,
    any,
    any,
    GridTreeNodeWithRender
  >,
  timestamp: string | null,
) {
  const days = params.value
  if (!timestamp || days === null) return null
  const lastSeenDate = new Date(timestamp)
  const daysText = days === 1 ? "day" : "days"
  const text = days > 0 ? `${days} ${daysText} ago` : "Today"
  return (
    <Tooltip title={`Last activity on ${lastSeenDate.toLocaleDateString()}`}>
      <Box
        display="flex"
        sx={{
          height: "100%",
          px: "10px",
          justifyContent: "left",
          alignItems: "center",
        }}
      >
        <Typography variant="body2">{text}</Typography>
      </Box>
    </Tooltip>
  )
}
